<template>
  <div id="app" >

    <headerbar 
    :room-options="rooms"
    :room.sync="room"
    :selected.sync="popoverType">
    </headerbar>

    <template v-if="noMasks === true">
    <!-- DESKTOP IMAGES -->
      <flat-configurator 
      class="desktop_configurator"
      v-for="setting in settings"
      v-if="desktop" 
      v-show="room === setting.room"
      room="setting.room" 
      size="desktop"
      :room="room"
      :base="setting.base"
      :bonus-options="cabinetBonusFeatures"
      :bonus="cabinetBonus"
      :cabinet-options="setting.cabinetOptions"
      :fabric-options="setting.fabricOptions"
      :cabinetcolor.sync="cabinetColor" 
      :fabricsuite.sync="fabricSuite"
      :images="setting.images">

      </flat-configurator>
      <!-- MOBILE IMAGES -->
      <flat-configurator 
      class="mobile_configurator"
      v-for="setting in settings"
      v-show="room === setting.room"
      room="setting.room" 
      size="mobile"
      :bonus-options="cabinetBonusFeatures"
      :bonus="cabinetBonus"
      :base="setting.mobileBase"
      :room="room"
      :cabinet-options="setting.cabinetOptions"
      :fabric-options="setting.fabricOptions"
      :cabinetcolor.sync="cabinetColor" 
      :fabricsuite.sync="fabricSuite"
      :images="setting.images">
      </flat-configurator>

    </template>
    <template v-else >
      <configurator 
      class="desktop_configurator"
      v-for="setting in settings"
      v-if="desktop" 
      v-show="room === setting.room"
      room="setting.room" 
      size="desktop"
      :room="room"
      :base="setting.base"
      :bonus-options="cabinetBonusFeatures"
      :bonus="cabinetBonus"
      :cabinet-options="setting.cabinetOptions"
      :fabric-options="setting.fabricOptions"
      :cabinetcolor.sync="cabinetColor" 
      :fabricsuite.sync="fabricSuite">
      </configurator>

      <!-- MOBILE IMAGES -->
      <configurator 
      class="mobile_configurator"
      v-for="setting in settings"
      v-show="room === setting.room"
      room="setting.room" 
      size="mobile"
      :bonus-options="cabinetBonusFeatures"
      :bonus="cabinetBonus"
      :base="setting.mobileBase"
      :room="room"
      :cabinet-options="setting.cabinetOptions"
      :fabric-options="setting.fabricOptions"
      :cabinetcolor.sync="cabinetColor" 
      :fabricsuite.sync="fabricSuite"
      chestnutimg="/static/img/kitchen-english-chestnut-m.png"
      cordovanimg="/static/img/kitchen-cordovan-m.png"
      alderwoodimg="/static/img/kitchen-base-m.jpg"
      alomndimg="/static/img/kitchen-toasted-almond-m.png"
      zestimg="/static/img/kitchen-zest-m.png"
      baseimg="/static/img/kitchen-base-m.jpg">
      </configurator>
    </template>

<!--     <configurator 
    class="desktop_configurator"
    v-if="desktop" 
    v-show="room === 'livingarea'"
    room="livingarea" 
    :cabinetcolor.sync="cabinetColor" 
    :fabricsuite.sync="fabricSuite"
    chestnutimg="/static/img/living-english-chestnut.png"
    cordovanimg="/static/img/living-cordovan.png"
    alderwoodimg="/static/img/living-base.jpg"
    alomndimg="/static/img/living-toasted-almond.png"
    zestimg="/static/img/living-zest.png"
    baseimg="/static/img/living-base.jpg">
    </configurator> -->

    

<!--     <configurator 
    class="mobile_configurator"
    v-show=" room === 'livingarea' " 
    room="livingarea" 
    :cabinetcolor.sync="cabinetColor" 
    :fabricsuite.sync="fabricSuite"
    chestnutimg="/static/img/living-english-chestnut-m.png"
    cordovanimg="/static/img/living-cordovan-m.png"
    alderwoodimg="/static/img/living-base-m.jpg"
    alomndimg="/static/img/living-toasted-almond-m.png"
    zestimg="/static/img/living-zest-m.png"
    baseimg="/static/img/living-base-m.jpg">
    </configurator> -->
    <popover class="intro" v-show="introOpen && desktop" transition = "expand">
      <div class="popover_header">             
         <h2>Now it's time to<br> personalize your coach.</h2>
         <div class="popover_stroke"></div>
      </div>
      <div class="popover_body popover_intro"><slot></slot></div>
    </popover>

    <popover :class="popoverType"  v-if="desktop" v-show="popoverOpen" transition = "expand">
        <cabinet-control :bonus="cabinetBonus" :room="room" :bonus-features="cabinetBonusFeatures" :settings="cabnetSettings" :selected.sync="cabinetColor" transition = "slide"  v-if="popoverType === 'cabinet' "></cabinet-control>
        <fabric-control :settings="fabricSettings" :selected.sync="fabricSuite" transition = "slide"  v-else></fabric-control>
    </popover>
    <accordion-tab class="room_accordion" title="Select Area">
      <a v-for="option in rooms" @click.prevent=" room = option " href="#"><span>{{option | capitalize }}</span></a>
      
    </accordion-tab>
    <accordion-tab title="CABINETS">
      <cabinet-control :bonus="cabinetBonus" :room="room" :bonus-features="cabinetBonusFeatures" :settings="cabnetSettings" :selected.sync="cabinetColor"></cabinet-control>
    </accordion-tab>
    <accordion-tab title="FABRIC">
      <fabric-control :settings="fabricSettings" :selected.sync="fabricSuite"></fabric-control>
    </accordion-tab>
  </div>
</template>
<script>
import headerbar from './components/headerbar' 
import configurator from './components/configurator'
import flatConfigurator from './components/flatConfigurator' 
import popover from './components/popover' 
import AccordionTab from './components/AccordionTab' 
import CabinetControl from './components/CabinetControl' 
import FabricControl from './components/FabricControl'
import Request from 'superagent'
export default {
  components: {
    headerbar,
    configurator,
    popover,
    AccordionTab,
    CabinetControl,
    FabricControl,
    flatConfigurator
  },
  data(){
    return {
      room: null,
      cabinetColor: null,
      fabricSuite: null,
      popoverOpen: false,
      popoverType: 'cabinet',
      introOpen: false,
      desktop: null,
      mobile: null,
      settings: null,
      cabinetBonus: false,
      noMasks: false
    }
  },
  props:['path'],
  computed: {
    cabnetSettings () {
      return this.settings[ 0 ].cabinetOptions
    },
    fabricSettings () {
      return this.settings[ 0 ].fabricOptions
    },
    flatImages () {
      if ( this.noMasks ) {

      }
    }, 
    cabinetBonusFeatures () {
      return this.settings.filter( item => item.cabinetFeatures ).map( item => {
        return { room: item.room, features: item.cabinetFeatures }
      })
    },
    rooms () {
      return this.settings.map( item => {
        return item.room
      })
    }
  },
  events: {
    'cabinet-changed' : function ( value ) {
      this.cabinetColor = value
    },
    'fabric-changed' : function ( value ) {
      this.fabricSuite = value
    },
    'popover-changed' : function ( value ) {
      this.popoverType = value
      this.popoverOpen = true
      this.introOpen = false
    },
    'popup-closed' : function () {
      this.popoverOpen = false
      this.introOpen = false
    },
    'cabinetbonus-changed' : function () {
      this.cabinetBonus = !this.cabinetBonus
    }
  },
  ready () {
     
    function determinIfPropExistsInArray( arr, key ) {
      let exists = false
      arr.forEach( item => {
        if( key in item ) {
          exists = true
        }
      })
      return exists
    }  

    Request
    .get(this.path)
    .end( (err, res) => {
      

        this.settings = res.body
        this.noMasks = determinIfPropExistsInArray(res.body, 'images')
        this.cabinetColor = this.settings[0].cabinetOptions[0].title.toLowerCase()
        this.fabricSuite = this.settings[0].fabricOptions[0].title.toLowerCase()
        this.room = this.rooms[0]

    })

    this.$watch( 'introOpen', function ( newVal ) {
      if ( newVal === false ) {
        this.popoverOpen = true
      }      
    })

    window.addEventListener( 'resize', () => {
      this.mobile = window.matchMedia("only screen and (max-width: 855px)").matches
      this.desktop = window.matchMedia("only screen and (min-width: 855px)").matches
    })
    this.mobile = window.matchMedia("only screen and (max-width: 855px)").matches
    this.desktop = window.matchMedia("only screen and (min-width: 855px)").matches
    this.$watch('room', () => {
	    this.popoverOpen = false
      this.introOpen = false
    })
    setTimeout( () => {
      this.introOpen = true
    }, 1000)
  }
}
</script>




/** WEBPACK FOOTER **
 ** App.vue?98f64dde
 **/